import react from "react";
import './Contacts.css';
import Canvas from "../Canvas/Canvas";

function Contacts() {
    return (
        <div className="contacts">
            <div className="info">
                <h3>РУКОВОДСТВО</h3>
                <p>Генеральный директор ООО НПП  «Альфа-Космос»<br></br>
                    <b>Диордица Алексей Владимирович</b></p>

                <h3>АДРЕС:</h3>
                <p>127015, Москва, ул. Большая Новодмитровская,дом 14 стр.7<br></br>
                    <span><b>Телефон: </b>8(495) 748-01-87</span><br></br>
                    <span><b>E-mail: </b>info@akosmos.ru</span><br></br>
                    <span><b>ИНН</b>  5006000373</span><br></br>
                    <span><b>КПП</b>  771501001</span><br></br>
                    <span><b>ОГРН</b> 1025001064550</span>
                </p>
            </div>
            <div className="map">
            <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A485468937807d0c232fc9bcd39ba9f1e3ed9e0b5b5c7ce51c04741addd60bb6e&amp;source=constructor" width="800" height="400" frameborder="0"></iframe>
            </div>
            <Canvas />
        </div>
    )
}

export default Contacts;